import React from 'react';

/** See https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85?permalink_comment_id=3570933#gistcomment-3570933 */
export const useBrowserLayoutEffect =
  typeof window !== 'undefined'
    ? React.useLayoutEffect
    : () => {
        // Do nothing
      };
